import React, { useEffect, useState } from 'react';
import { formatDateTime } from '../LiveChallenge/formatters';
import { INTENT_LABELS, OUTCOME_LABELS, ROLE_LABELS, label } from './labels';

const PAGE_SIZE = 20;

export function MessagesTable({ items = [] }) {
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));

  useEffect(() => setPage(1), [items]);

  if (!items.length) return <p className="report-widget__subtitle">Nenhuma mensagem encontrada para os filtros.</p>;

  const visible = items.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <table className="w-full text-left text-sm">
          <thead>
            <tr>
              {['Data', 'Aluno', 'Escola / turma', 'Quem', 'Mensagem', 'Desfecho', 'Intenção', 'Seção', 'Tela'].map(title => (
                <th
                  key={title}
                  className="px-2 py-2 font-semibold"
                >
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visible.map(item => (
              <tr
                key={`${item.role}-${item.message_id}`}
                className="align-top border-t"
                style={item.flagged ? { background: 'rgba(229, 72, 77, 0.06)' } : undefined}
              >
                <td className="px-2 py-2 whitespace-nowrap">{formatDateTime(item.created_at)}</td>
                <td className="px-2 py-2">
                  <div>{item.student_email}</div>
                  <div className="text-xs">id {item.student_id}</div>
                </td>
                <td className="px-2 py-2">
                  <div>{item.institutions?.join(', ') || '-'}</div>
                  <div className="text-xs">{item.classrooms?.join(', ')}</div>
                </td>
                <td className="px-2 py-2">
                  {label(ROLE_LABELS, item.role)}
                  {item.flagged && item.role === 'student' ? ' 🚩' : ''}
                </td>
                <td
                  className="px-2 py-2"
                  style={{ maxWidth: 420, whiteSpace: 'pre-wrap' }}
                >
                  {item.body}
                </td>
                <td className="px-2 py-2">{label(OUTCOME_LABELS, item.outcome) ?? '-'}</td>
                <td className="px-2 py-2">{label(INTENT_LABELS, item.intent) ?? '-'}</td>
                <td className="px-2 py-2">{item.section ?? '-'}</td>
                <td className="px-2 py-2 text-xs">{item.current_path ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-3 pt-3 text-sm">
        <button
          type="button"
          className="btn btn--outline"
          disabled={page <= 1}
          onClick={() => setPage(current => current - 1)}
        >
          Anterior
        </button>
        <span>
          {page} de {pages}
        </span>
        <button
          type="button"
          className="btn btn--outline"
          disabled={page >= pages}
          onClick={() => setPage(current => current + 1)}
        >
          Próxima
        </button>
      </div>
    </div>
  );
}
